import { IPrivateIndividualInformationBaseViewModel } from 'viewModels';
import api from '../services/api/axios';

const getPrivateIndividual = (document: string, birthDate: Date) =>
  new Promise<IPrivateIndividualInformationBaseViewModel>((resolve) => {
    api
      .get(`informationbaseprivateindividual/${document}`,{
        params: {
          birthDate
        }
      })
      .then(({ data }) => resolve(data))
      .catch();
  });

const InformationBasePrivateIndividualController = { getPrivateIndividual };

export default InformationBasePrivateIndividualController;
